export const NotificationMessageTypes = {
  notification: "Notification",
  email: "Email"
}
